/* This hook is supposed to replace withAnalytics HOC. WithAnalytics has a 
rendering problem which is causing performance issues */

import { useEffect, useRef } from 'react';

const useIntersectionObserver = (callback, options) => {
  const elementRef = useRef(null);

  useEffect(() => {
    const handleIntersection = (entries) => {
      if (entries && entries[0].isIntersecting) {
        callback();  
      }
    };

    const observer = new IntersectionObserver(handleIntersection, options);

    if (elementRef.current) {
      observer.observe(elementRef.current);
    }

    return () => {
      if (elementRef.current) {
        observer.unobserve(elementRef.current);
      }
    };
  }, [callback, options]);

  return { inViewRef: elementRef };
};

export default useIntersectionObserver;
